import * as axioCaller from "@services/axio-caller";
import { saveJsonApiDataToStore } from "./save-resource-to-store";
import { formErorHandler } from "@services/error-handler";

export interface ResourceConfig {
  baseUrl: string;
  storeRegistry: Record<string, unknown>;
  apiScope?: string;
}

export async function fetchModelResources(
  config: ResourceConfig,
  params: Record<string, unknown>,
) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axioCaller.get({
        url: `${config.baseUrl}`,
        options: params,
        apiScope: config.apiScope,
      });

      saveJsonApiDataToStore(config.storeRegistry, response.data);

      resolve(response);
    } catch (e) {
      formErorHandler(e);
      reject();
    }
  });
}

export async function findModelResource(
  config: ResourceConfig,
  id: string | number,
  options: { url?: string; params?: Record<string, unknown> } = {},
) {
  const url = options.url || `${config.baseUrl}/${id}`;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axioCaller.get({
        url,
        options: options.params,
        apiScope: config.apiScope,
      });

      saveJsonApiDataToStore(config.storeRegistry, response.data);

      resolve(response);
    } catch (e) {
      formErorHandler(e);
      reject(e);
    }
  });
}

export async function createModelResource(
  config: ResourceConfig,
  {
    form,
    formErrors,
    options = {},
  }: {
    form: Record<string, unknown>;
    formErrors: Record<string, unknown>;
    options?: Record<string, unknown>;
  },
) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axioCaller.postApiForm({
        url: `${config.baseUrl}`,
        form,
        options,
        apiScope: config.apiScope,
      });

      saveJsonApiDataToStore(config.storeRegistry, response.data);

      resolve(response);
    } catch (e) {
      formErorHandler(e, formErrors);
      reject(e);
    }
  });
}

export async function updateModelResource(
  config: ResourceConfig,
  {
    id,
    form,
    formErrors,
    url,
    options = {},
  }: {
    id: string | number;
    form: Record<string, unknown>;
    formErrors: Record<string, unknown>;
    url?: string;
    options?: Record<string, unknown>;
  },
) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axioCaller.putApiForm({
        url: url || `${config.baseUrl}/${id}`,
        form,
        options,
        apiScope: config.apiScope,
      });

      saveJsonApiDataToStore(config.storeRegistry, response.data);

      resolve(response);
    } catch (e) {
      formErorHandler(e, formErrors);

      reject(e);
    }
  });
}

export async function destroyModelResource(
  config: ResourceConfig,
  id: string | number,
) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axioCaller.destroy({
        url: `${config.baseUrl}/${id}`,
        apiScope: config.apiScope,
      });

      resolve(response);
    } catch (e) {
      reject();
    }
  });
}
